import './Background.css';

/**
 * Decorative background layer: animated mesh gradient, grid, noise texture
 * and a cursor-following radial glow. Pure presentation, fully a11y-hidden.
 */
export function Background() {
  return (
    <div className="bg-layer" aria-hidden>
      <div className="bg-mesh" />
      <div className="bg-grid" />
      <div className="bg-noise" />
      <div className="bg-cursor" />
    </div>
  );
}
